import React, { Component } from 'react';

class Skills extends Component {
    render() {
        return (
            <>
                <div className='col-10 p-3 my-3 mx-auto skills' id="skills">
                <h4 className='title text-center'>Skills</h4>
                    <div className="row col-lg-8 mb-4 mx-auto">
                        <div className="lead col-lg-3 my-2">Languages:</div>
                        <div className='col-lg-6 mx-auto my-2 d-flex justify-content-between'>
                            <div className="badge badge-success">Javascript</div>
                            <div className="badge badge-warning">Python</div>
                            <div className="badge badge-danger">Php</div>
                        </div>
                    </div>
                    <div className="row col-lg-10 mx-auto">
                        <div className="lead col-lg-4 my-2">Library And Frameworks:</div>
                        <div className="d-flex col-lg-8 my-2 justify-content-between">
                            <div className="badge badge-success p-1">React js</div>
                            <div className="badge badge-warning p-1">Redux</div>
                            <div className="badge badge-primary p-1">Laravel</div>
                            <div className="badge badge-dark p-1">Jquery</div>
                        </div>
                    </div>
                    <div className="d-flex col-lg-4 mx-auto my-2 justify-content-between">
                        <div className="badge badge-warning p-1">Bootstrap 4</div>
                        <div className="badge badge-dark p-1">Express js</div>
                        <div className="badge badge-success p-1">Node js</div>
                    </div>
                    <div className="row col-lg-8 mt-4 mx-auto">
                        <div className="lead col-lg-3 my-2">Databases:</div>
                        <div className='col-lg-6 mx-auto my-2 d-flex justify-content-between'>
                            <div className="badge badge-success">Mysql</div>
                            <div className="badge badge-warning">Oracle</div>
                            <div className="badge badge-info">Sql</div>
                            <div className="badge badge-danger">MongoDb</div>
                        </div>
                    </div>
                    <div className="row col-lg-8 mt-4 mx-auto">
                        <div className="lead col-lg-3 my-2">Data Analysis:</div>
                        <div className='col-lg-6 mx-auto my-2 d-flex justify-content-between'>
                            <div className="badge badge-success">Numpy</div>
                            <div className="badge badge-warning">Scipy</div>
                            <div className="badge badge-danger">Pandas</div>
                            <div className="badge badge-dark">Matplotlib</div>
                        </div>
                    </div>
                    <div className="d-flex col-lg-4 mx-auto my-2 justify-content-between">
                        <div className="badge badge-warning p-1">Machine Learning</div>
                        <div className="badge badge-dark p-1">D3 js</div>
                        <div className="badge badge-success p-1">R</div>
                    </div>
                    <div className="row col-lg-10 mt-4 mx-auto">
                        <div className="lead col-lg-3 my-2">Expertise: </div>
                        <div className='col-lg-9'>
                            <p className='lead'>SDLC (<i className='p-1'>Scrum</i>) , Responsive Web-development, Software-Testing, Restful Apis, Cloud-Computing (<i className='p-1'>Scrum</i>),
                            Data structures and Algorithms, Data visualisation & Analysis.
                            </p>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default Skills;